var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogitechA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3008",
    className: "cls-1",
    d: "m34.74,19.58V7.27h2.16v12.31h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3010",
    className: "cls-1",
    d: "m42.43,10.65c-2.77,0-4.69,2.13-4.69,4.57,0,2.72,2.09,4.6,4.71,4.6s4.65-1.84,4.65-4.6c0-2.32-1.79-4.56-4.67-4.56h0Zm-.03,2.09c1.45,0,2.52,1.13,2.52,2.49,0,1.45-1.18,2.5-2.48,2.5-1.54,0-2.51-1.22-2.51-2.5,0-1.4,1.09-2.5,2.47-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3012",
    className: "cls-1",
    d: "m52.54,10.65c-2.77,0-4.69,2.13-4.69,4.57,0,2.72,2.09,4.6,4.71,4.6s4.65-1.84,4.65-4.6c0-1.63-.7-2.35-.7-2.35l.6-.21v-1.75h-3.07s-.67-.26-1.5-.26h0Zm-.03,2.09c1.45,0,2.52,1.13,2.52,2.49,0,1.45-1.18,2.5-2.48,2.5-1.54,0-2.51-1.22-2.51-2.5,0-1.4,1.09-2.5,2.47-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    className: "cls-1",
    d: "m55.02,20.18c0,1.45-1.18,2.51-2.48,2.51-1.54,0-2.51-1.23-2.51-2.51h-2.19c0,2.72,2.09,4.6,4.71,4.6s4.65-1.84,4.65-4.6h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3016",
    className: "cls-1",
    d: "m58.08,19.58v-8.67h2.16v8.67h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    className: "cls-1",
    d: "m62.34,19.58v-6.73h-1.16v-1.94h1.16v-2.66h2.16v2.66h1.19v1.94h-1.19v6.73h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3020",
    className: "cls-1",
    d: "m60.59,8.44c0,.79-.64,1.43-1.43,1.43s-1.43-.64-1.43-1.43.64-1.43,1.43-1.43,1.43.64,1.43,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3022",
    className: "cls-1",
    d: "m70.55,10.64c-2.78,0-4.58,2.13-4.58,4.65s1.8,4.53,4.63,4.53c2.63,0,3.93-1.64,3.93-1.64l-1.45-1.45s-1.09,1.18-2.46,1.18c-1.14,0-2.05-.64-2.37-1.8h6.74v-.6c0-2.38-1.37-4.87-4.44-4.87Zm-.07,1.9c1,0,2.01.53,2.24,1.81h-4.53c.18-.89.96-1.81,2.29-1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3024",
    className: "cls-1",
    d: "m80.4,19.83c-2.79,0-4.7-2.13-4.7-4.64s2.15-4.55,4.69-4.55,3.71,1.73,3.71,1.73l-1.51,1.5s-.87-1.13-2.21-1.13c-1.48,0-2.49,1.13-2.49,2.48,0,1.42,1.08,2.51,2.48,2.51s2.22-1.13,2.22-1.13l1.52,1.5s-1.24,1.72-3.71,1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3026",
    className: "cls-1",
    d: "m84.9,19.58V7.24h2.16v4.54s.83-1.13,2.63-1.13c2.26,0,3.58,1.68,3.58,3.84v5.11h-2.16v-4.78c0-1.45-.9-2.05-1.9-2.05-1.14,0-2.14.65-2.14,2.16v4.67h-2.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogitechA);
export default __webpack_public_path__ + "static/media/Logitech-a.94fd5d1c887ca942383a3e765fbf8750.svg";
export { ForwardRef as ReactComponent };